import { forEach as _forEach } from 'lodash';
import React from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import {Row, Col, Image, Clearfix, Button} from 'react-bootstrap';

import PositionsInfos from 'components/layout/PositionsInfos';
import SalesDocumentSummary from 'components/layout/SalesDocumentSummary';
import IntlDate from 'components/layout/IntlDate';
import InvoiceAuthorizeButton from 'components/layout/financial/InvoiceAuthorizeButton';

import RichEditorContent from 'components/RichEditorContent';
import ProvisionServiceDocumentsDownload from "../modals/ProvisionServiceDocumentsDownload";
import Axios from "axios";
import {confirmAlert} from "react-confirm-alert";

/*import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import List from 'components/List';
import Loader from 'components/layout/Loader';
import DocMeta from 'components/DocMeta';
import { generateMetaTags } from 'helpers/metaTags';
import may from 'js/security';
import { ROLE_ROOT_EMPLOYEE } from 'js/constants';*/

import SalesCommissionList from "./financial/SalesCommissionList";
import CommissionServicePdfButton from "./financial/CommissionServicePdfButton";


class CommissionInvoiceView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      printing: false,
      showDownloadOptions: false
    };
  }
  getDocuments = (searchDate) => {
    const {intl: { messages }} = this.props;
    this.setState({ printing: true });
    let FileDownload;
    FileDownload = require('js-file-download');
    /* TODO muss durch downloadadresse für provisionservice dokumente ersetzt werden ggf. mit auswahl welcher monat */
    Axios({
      url: '/api/commissions/sales/list.json?offset=0&limit=50&search=&sort=cdate&dir=desc&page=1&_locale=de&csv=commissions', //Todo your url insert, searchDate to api
      method: 'GET',
      responseType: 'blob',
    })

      .then((response) => {

        FileDownload(response.data, 'provisionServices.csv');
        this.setState({ printing: false}, () => {
          const options = {
            customUI: ({ onClose }) => {
              return (
                <div className='react-confirm-alert-body'>
                  <h1>{messages.salesDoc.download_csv_ready}</h1>
                  <div className="react-confirm-alert-button-group" style={{ width: "100%", margin: "0 auto" }}>
                    <Button style={{ margin: "0 auto", marginTop: "20px", width: "100px" }} bsStyle="primary" onClick={onClose}>OK</Button>
                  </div>
                </div>
              );
            },
            childrenElement: () => <div />,
            closeOnEscape: true,
            closeOnClickOutside: true,
          };
          confirmAlert(options);
        });

      })
      .catch((error) => {
        // handle error
        if (Axios.isCancel(error)) {
          console.log("post Request canceled");
        } else {
          console.log(error);
        }
      });
  }
  readData = field => {
    if (field !== undefined) {
      return field;
    }

    return '';
  };

  getClientData = data => {
    return {
      company: this.readData(data.company),
      firstName: this.readData(data.first_name),
      lastName: this.readData(data.last_name),
      street: this.readData(data.street),
      houseNumber: this.readData(data.house_number),
      apartmentNumber: this.readData(data.apartment_number),
      addressLine2: this.readData(data.address_line2),
      zipCode: this.readData(data.zip_code),
      city: this.readData(data.city),
      vatIdName: this.readData(data.vat_id_name),
      vatId: this.readData(data.vat_id),
    };
  };

  getOwnerData = () => {
    const { data } = this.props;
    return this.getClientData(data.owner_data);
  };

  showTargetData = (targetData, vatIdName) => {
    return (
      <>
        {!!targetData.company && <strong>{targetData.company}</strong>}
        {targetData.company ? <br /> : null}
        {targetData.firstName} {targetData.lastName}
        <br />
        {targetData.street} {targetData.houseNumber} {targetData.apartmentNumber}
        <br />
        {targetData.addressLine2 ? (
          <>
            {targetData.addressLine2}
            <br />
          </>
        ) : null}
        {targetData.zipCode} {targetData.city}
        <br />
        {!!targetData.company && (
          <span>
            {vatIdName} {targetData.vatId}
          </span>
        )}
      </>
    );
  };

  render() {
      const {
        intl: { messages },
        data,
      } = this.props;

      const {
        is_auto_generated: isAutoGenerated,
        is_authorized: isAuthorized,
        authorized_on: authorizedOn,
        authorized_by_name: authorizedByName,
      } = data;

      const ownerData = this.getOwnerData();

      let invoices_number = '';
      _forEach (data.invoices, (invoice, i) => {
        invoices_number += ((i > 0) ? ', ' : '') + invoice.number;
      });

      return (
        <Clearfix>
          <Col xs={12} md={6}>
            <div>
              {!!data.owner_logo && (
                <Image src={data.owner_logo} responsive style={{ maxHeight: '100px', maxWidth: '200px' }} />
              )}
            </div>
            <p>&nbsp;</p>
            <Row>
              <Col xs={3}>
                <div className="text-right">{messages.provisionDoc.provision}</div>
              </Col>
              <Col xs={9}>
                <strong>
                  #{data.number_prefix || ''}
                  {data.number || '?'}
                </strong>
              </Col>
            </Row>
            <Row>
              <Col xs={3}>
                <div className="text-right">{messages.commission_service_documents}</div>
              </Col>
              <Col xs={9}>
                #{invoices_number}
              </Col>
            </Row>
            <Row>
              <Col xs={3}>
                <div className="text-right">{messages.salesDoc.issued}</div>
              </Col>
              <Col xs={9}>
                <IntlDate date={data.cdate} />
              </Col>
            </Row>
            {!!data.period && !!data.period.date_from && !!data.period.date_to && (
              <Row>
                <Col xs={3}>
                  <div className="text-right">{messages.salesDoc.billing_period}</div>
                </Col>
                <Col xs={9}>
                  <IntlDate date={data.period.date_from} /> - <IntlDate date={data.period.date_to} />
                </Col>
              </Row>
            )}
            {!!data.pdf && !!data.pdf.hasError == false && (
              <Row>
                <Col xs={3}>
                  <div className="text-right">{messages.provisionDoc.download_pdf}</div>
                </Col>
                <Col xs={9}>
                  <CommissionServicePdfButton invoice={data} key="pdf" />
                </Col>
              </Row>
            )}
          </Col>

          <Col xs={12} md={6}>
            <Row>
              <Col xs={6}>
                <div className="text-right">{messages.salesDoc.invoice_from}</div>
              </Col>
              <Col xs={6}>
                <strong>{ownerData.company}</strong>
                <br />
                {ownerData.firstName} {ownerData.lastName}
                <br />
                {ownerData.street} {ownerData.houseNumber} {ownerData.apartmentNumber}
                <br />
                {ownerData.addressLine2 ? (
                  <>
                    {ownerData.addressLine2}
                    <br />
                  </>
                ) : null}
                {ownerData.zipCode} {ownerData.city}
                <br />
                {ownerData.vatIdName} {ownerData.vatId}
              </Col>
            </Row>

            <p>&nbsp;</p>
            <Row>
              <Col xs={6}>
                <div className="text-right">{messages.provisionDoc.provision_for}</div>
              </Col>
              <Col xs={6}>
                {this.showTargetData(
                  this.getClientData(data.target_data),
                  ownerData.vatIdName
                )}
              </Col>
            </Row>

            <>
              <p>&nbsp;</p>
              <Row>
                <Col xs={6}>
                  <div className="text-right">{messages.client}</div>
                </Col>
                <Col xs={6}>{this.showTargetData(this.getClientData(data.target_data), ownerData.vatIdName)}</Col>
              </Row>
            </>
          </Col>

          <Row>
            <Col xs={12}>
              <h2>{messages.provision_service_documents}</h2>
              <SalesCommissionList list={data.positions} listName="provisionService" />
            </Col>
            <Col xs={7} xsOffset={5}>
              <SalesDocumentSummary doc={data} />
            </Col>
          </Row>

          <ProvisionServiceDocumentsDownload
            show={this.state.showDownloadOptions}
            close={() => this.setState({ showDownloadOptions: false })}
            getDocuments={this.getDocuments}
          />

          {!!data.comment && (
            <Row>
              <Col xs={6}>
                <RichEditorContent content={data.comment} />
              </Col>
            </Row>
          )}
        </Clearfix>
      );
  }
}

export default injectIntl(CommissionInvoiceView);
